import axios from 'axios';
import { ChainType, PickingChainEntry } from '../models/PickingChainEntry';

const API_URL = `${process.env.REACT_APP_API_URL}/api/picking-chain-entries/`;

type ListParams = {
  chain_type?: ChainType;
};

export interface ProductOption {
  id: number;
  ean: string;
  name: string;
}

export function listPickingChainEntries(
  params: ListParams = {}
): Promise<{ data: PickingChainEntry[] }> {
  return axios.get(API_URL, { params });
}

export function createPickingChainEntry(
  data: Omit<PickingChainEntry, 'id'>
): Promise<{ data: PickingChainEntry }> {
  return axios.post(API_URL, data);
}

export function updatePickingChainEntry(
  id: number,
  data: Partial<PickingChainEntry>
): Promise<{ data: PickingChainEntry }> {
  return axios.put(`${API_URL}${id}/`, data);
}

export function deletePickingChainEntry(id: number): Promise<void> {
  return axios.delete(`${API_URL}${id}/`);
}

export function searchProductOptions(
  search: string = ''
): Promise<{ data: ProductOption[] }> {
  return axios.get(`${API_URL}product-options/`, { params: { search } });
}

export function searchExternalProductOptions(
  search: string = ''
): Promise<{ data: ProductOption[] }> {
  return axios.get(`${API_URL}external-product-options/`, {
    params: { search },
  });
}
